<?xml version="1.0" encoding="UTF-8"?>
<svg width="151px" height="8px" viewBox="0 0 151 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 52.5 (67469) - http://www.bohemiancoding.com/sketch -->
    <title>Group</title>
    <desc>Created with Sketch.</desc>
    <defs>
        <linearGradient x1="100%" y1="6.18582821%" x2="3.48566002%" y2="100%" id="linearGradient-line-red-1">
            <stop stop-color="#FF8468" offset="0%"></stop>
            <stop stop-color="#FF695B" offset="52.2014993%"></stop>
            <stop stop-color="#E23030" offset="100%"></stop>
        </linearGradient>
        <linearGradient x1="100%" y1="6.18582821%" x2="3.48566002%" y2="100%" id="linearGradient-line-red-2">
            <stop stop-color="#FF8468" offset="0%"></stop>
            <stop stop-color="#E34040" offset="100%"></stop>
        </linearGradient>
        <linearGradient x1="100%" y1="6.18582821%" x2="3.48566002%" y2="100%" id="linearGradient-line-red-3">
            <stop stop-color="#FF8468" offset="0%"></stop>
            <stop stop-color="#E34B4B" offset="97.7555997%"></stop>
        </linearGradient>
    </defs>
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="criteria/grade/bad" transform="translate(-4.000000, -6.000000)">
            <g id="radio" transform="translate(2.000000, 6.000000)">
                <g id="Group" transform="translate(2.000000, 0.000000)">
                    <g id="Red-line">
                        <rect id="gray_base" fill="#E5E5E5" x="4" y="3" width="143" height="2"></rect>
                        <circle id="Oval-2" stroke-opacity="0" stroke="#FFFFFF" stroke-width="2" fill-opacity="0" fill="#FFFFFF" cx="148" cy="4" r="3"></circle>
                        <path d="M4,7 C2.34314575,7 1,5.65685425 1,4 C1,2.34314575 2.34314575,1 4,1 C5.65685425,1 7,2.34314575 7,4 C7,5.65685425 5.65685425,7 4,7 Z M40,7 C38.3431458,7 37,5.65685425 37,4 C37,2.34314575 38.3431458,1 40,1 C41.6568542,1 43,2.34314575 43,4 C43,5.65685425 41.6568542,7 40,7 Z M76,7 C74.3431458,7 73,5.65685425 73,4 C73,2.34314575 74.3431458,1 76,1 C77.6568542,1 79,2.34314575 79,4 C79,5.65685425 77.6568542,7 76,7 Z M148,7 C146.343146,7 145,5.65685425 145,4 C145,2.34314575 146.343146,1 148,1 C149.656854,1 151,2.34314575 151,4 C151,5.65685425 149.656854,7 148,7 Z" id="base" fill="#E5E5E5"></path>
                        <circle id="Oval-2" fill="#E5E5E5" cx="112" cy="4" r="3"></circle>
                        <circle id="Oval-2" stroke-opacity="0" stroke="#FFFFFF" stroke-width="2" fill-opacity="0" fill="#FFFFFF" cx="4" cy="4" r="3"></circle>
                    </g>
                    <g id="Group-2">
                        <polygon id="gradient_line" fill="url(#linearGradient-line-red-1)" points="6 3 77 3 77 5 6 5"></polygon>
                        <circle id="Oval-2" stroke="url(#linearGradient-line-red-2)" stroke-width="2" fill="#FFFFFF" cx="40" cy="4" r="3"></circle>
                        <circle id="Oval-2" stroke="url(#linearGradient-line-red-2)" stroke-width="2" fill="#FFFFFF" cx="4" cy="4" r="3"></circle>
                        <circle id="Oval-2" stroke="url(#linearGradient-line-red-3)" stroke-width="2" fill="#FFFFFF" cx="76" cy="4" r="3"></circle>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>